import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeTwoToneIcon from "@mui/icons-material/HomeTwoTone";
import ArrowBackTwoToneIcon from "@mui/icons-material/ArrowBackTwoTone";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Button, Collapse, ListItemButton } from "@mui/material";
import { Dialog, DialogContent, DialogContentText } from "@mui/material";
import { DialogActions } from "@mui/material";
import SettingsTwoToneIcon from "@mui/icons-material/SettingsTwoTone";
import PeopleAltTwoToneIcon from "@mui/icons-material/PeopleAltTwoTone";
import ManageAccountsTwoToneIcon from "@mui/icons-material/ManageAccountsTwoTone";
import LibraryBooksTwoToneIcon from "@mui/icons-material/LibraryBooksTwoTone";
import AttachFileTwoToneIcon from "@mui/icons-material/AttachFileTwoTone";
import PetsTwoToneIcon from "@mui/icons-material/PetsTwoTone";
import img from "../../Assets/Images/VULPES LOGO V1 SUPORTE 64.png";
import { OpcaoSair } from "./opcao_sair";
import { cores, versao } from "../../Func_genericas/valores_estaticos";
import { ChangeRole } from "../../Func_genericas/change_role";
import { AuthContext } from "../../AuthContext/AuthContext";
import Mudarvistatecnicoadmin from "../../Components/CustomDialog/confirmar_mudar_tecnico_admin";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    active: {
      background: "#7E2706",
      color: "#ffffff",
      "& .MuiSvgIcon-root": {
        color: "#ffffff",
      },
      // maxWidth:"fit-content",
      wordBreak: "break-all",

      // style={{ maxWidth: "fit-content", wordBreak: "break-all" }}
    },
    footer: {
      width: "100%",
      height: "40px",
      position: "fixed",
      fontFamily: "candara",
      bottom: 20,
      left: 20,
    },
  })
);

// View do administrador 2GF
export function Admin2View() {
  const classes = useStyles();
  const location = useLocation();
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const [openConnfirm, setOpenConfirm] = useState(false);

  const handleMudarView = () => {
    ChangeRole(auth, navigate);
  };

  const handleClickOpenMudarView = (
    newAlignment: string,
  ) => {
    let aux_value = auth.user_role === 'admin' ? 'Administrador' : 'Consultor'
    if (newAlignment && newAlignment !== aux_value)
      setOpenConfirm(true);
  };

  return (
    <>
      <div style={{
        // backgroundColor: 'red',
        display: "flex",
        flexDirection: 'row',
        alignItems: "center",
        justifyContent: 'center',
        height: 45,
        marginTop: 10,
        marginBottom: 5,
        marginLeft: 4,
        marginRight: 4,
        borderRadius: 5,
        border: `1px solid ${cores.cor1}`,
      }}>
        <div style={{
          backgroundColor: auth.user_role === 'admin' ? cores.cor1 : 'white',
          display: "flex",
          flexDirection: 'row',
          alignItems: "center",
          justifyContent: 'center',
          flex: 0.5,
          height: '100%',
          color: auth.user_role === 'admin' ? 'white' : 'black',
          borderTopLeftRadius: 5,
          borderBottomLeftRadius: 5

        }}
          onClick={() => { handleClickOpenMudarView('admin') }}
        >
          Administrador
        </div>
        <div style={{
          backgroundColor: auth.user_role === 'tecnico' ? cores.cor1 : 'white',
          display: "flex",
          flexDirection: 'row',
          alignItems: "center",
          justifyContent: 'center',
          flex: 0.5,
          height: '100%',
          color: auth.user_role === 'tecnico' ? 'white' : 'black',
          borderTopRightRadius: 5,
          borderBottomRightRadius: 5

        }}
          onClick={() => { handleClickOpenMudarView('tecnico') }}

        >
          Consultor
        </div>
      </div>

      <List style={{
        fontFamily: "candara", fontSize: 16,
        flex: 1,

      }}>
        <ListItem
          // button
          component={Link}
          to="/"
          className={location.pathname === "/" ? classes.active : ""}
        >
          <ListItemIcon>
            <HomeTwoToneIcon sx={{ color: "#c94f1e" }} />
          </ListItemIcon>
          <ListItemText sx={{ color: location.pathname !== "/" ? 'black' : 'white' }} disableTypography primary="Inicio" />
        </ListItem>
        <ListItem
          // button
          component={Link}
          to="/gestaotecnicos"
          className={
            location.pathname === "/gestaotecnicos" ? classes.active : ""
          }
        >
          <ListItemIcon>
            <ManageAccountsTwoToneIcon sx={{ color: "#c94f1e" }} />
          </ListItemIcon>
          <ListItemText sx={{ color: location.pathname === "/gestaotecnicos" ? 'white' : 'black' }} disableTypography primary="Gestão de Utilizadores" />
        </ListItem>
        <ListItem
          // button
          component={Link}
          to="/gestaoBeneficiarios"
          className={
            location.pathname === "/gestaoBeneficiarios" ? classes.active : ""
          }
        >
          <ListItemIcon>
            <PeopleAltTwoToneIcon sx={{ color: "#c94f1e" }} />
          </ListItemIcon>
          <ListItemText sx={{ color: location.pathname === "/gestaoBeneficiarios" ? 'white' : 'black' }} disableTypography primary="Gestão de Beneficiários" />
        </ListItem>
        <ListItem
          // button
          component={Link}
          to="/definicoes"
          className={location.pathname === "/definicoes" ? classes.active : ""}
        >
          <ListItemIcon>
            <SettingsTwoToneIcon sx={{ color: "#c94f1e" }} />
          </ListItemIcon>
          <ListItemText sx={{ color: location.pathname === "/definicoes" ? 'white' : 'black' }} disableTypography primary="Definições" />
        </ListItem>

        <ListItem
          // button
          component={Link}
          to="/suporte"
          className={location.pathname === "/suporte" ? classes.active : ""}
        >
          <ListItemIcon>
            <img
              src={img}
              alt="suporte"
              style={{ width: "24px", height: "24px" }}
            />
          </ListItemIcon>
          <ListItemText sx={{ color: location.pathname === "/suporte" ? 'white' : 'black' }} disableTypography primary="Suporte" />
        </ListItem>

        {/** Mudar de vista */}
        <Divider />
        {/* <ListItemButton
          onClick={handleClickOpenMudarView}
        >
          <ListItemIcon>
            <SupervisorAccountIcon sx={{ color: "#c94f1e" }} />
          </ListItemIcon>
          <ListItemText
            style={{
              fontFamily: "candara",
              fontSize: 18,
              color: cores.cor1
            }}
            disableTypography primary="Modo Administrador" />
        </ListItemButton> */}


        <Mudarvistatecnicoadmin
          open={openConnfirm}
          onClose={() => setOpenConfirm(false)}
          onConfirm={handleMudarView} />

        <Divider />

        <OpcaoSair />

        {/* Rodapé */}

      </List>
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        fontSize: 15,

      }}>
        {versao.versao}

      </div>
    </>
  );
}
interface CadernoViewProps {
  open: boolean;
}

//View inicial dos Tecnicos
export function CadernoView({ open }: CadernoViewProps) {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useContext(AuthContext);

  const flag_abrir_anexos = () => {
    if (location.pathname === '/Anexo1' ||
      location.pathname === '/Anexo2' ||
      location.pathname === '/Anexo3' ||
      location.pathname === '/Anexo4' ||
      location.pathname === '/Anexo5' ||
      location.pathname === '/Anexo6' ||
      location.pathname === '/Anexo7'
    ) {
      return true
    } else {
      return false
    }
  }
  const flag_abrir_cadernos = () => {
    if (location.pathname === '/IdentificacaoBenExp' ||
      location.pathname === '/CaraterizacaoAreas' ||
      location.pathname === '/CaracterizacaoEfePecuaria' ||
      location.pathname === '/RegistoProtFitossanitaria' ||
      location.pathname === '/RegistoOperCulturais' ||
      location.pathname === '/RegOperFertil' ||
      location.pathname === '/RegAtividades' ||
      location.pathname === '/RegAtividPP' ||
      location.pathname === '/RegAtividadesFO' ||
      location.pathname === '/RegCalRega' ||
      location.pathname === '/RegProducaoAnimal' ||
      location.pathname === '/RegPosColheita' ||
      location.pathname === '/RegAquisicoesEntra' ||
      location.pathname === '/RegVendas' ||
      location.pathname === '/RegGestaoEP'
    ) {
      return true
    } else {
      return false
    }
  }

  const [openDialog, setOpenDialog] = React.useState(false);
  const [openConnfirm, setOpenConfirm] = useState(false);

  const handleMudarView = () => {
    ChangeRole(auth, navigate);
  };

  const handleClickOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const [openSubMenu, setOpenSubMenu] = useState(flag_abrir_cadernos());
  const handleClickSubMenu = () => {
    setOpenSubMenu(!openSubMenu);
  };

  const [openAnexos, setOpenAnexos] = useState(flag_abrir_anexos());
  const handleClickAnexos = () => {
    setOpenAnexos(!openAnexos);
  };



  const handleBack = () => {
    navigate("/");
  };



  return (
    <>
      <List style={{ fontFamily: "candara", fontSize: 16, flex: 1 }}>
        <ListItemButton onClick={handleClickSubMenu}>
          <ListItemIcon>
            <LibraryBooksTwoToneIcon sx={{ color: "#c94f1e" }} />
          </ListItemIcon>
          <ListItemText
            disableTypography
            primary={<strong>Caderno Campo</strong>}
          />
          {openSubMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
          <List component="div">
            <ListItem
              // button
              component={Link}
              to="/IdentificacaoBenExp"
              className={
                location.pathname === "/IdentificacaoBenExp" ||
                  location.pathname === "IdentificacaoBenExp"
                  ? classes.active
                  : ""
              }
              state={location.state}
            >
              <ListItemText
                disableTypography
                // style={{ maxWidth: "fit-content", wordBreak: "break-all" }}
                sx={{
                  color: location.pathname === "/IdentificacaoBenExp" ? 'white' : 'black',
                  whiteSpace: open !== true ? 'nowrap' : "normal",
                  wordBreak: open !== true ? 'break-word' : "keep-all",
                }}
                primary="1. Ident. Beneficiário e da Exploração"
              />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/CaraterizacaoAreas"
              className={
                location.pathname === "/CaraterizacaoAreas" ? classes.active : ""
              }
              state={location.state}
            >
              <ListItemText
                disableTypography
                sx={{
                  color: location.pathname === "/CaraterizacaoAreas" ? 'white' : 'black',
                  whiteSpace: open !== true ? 'nowrap' : "normal",
                  wordBreak: open !== true ? 'break-word' : "keep-all",
                }}

                primary="2. Carat. Areas sob compromisso"
              />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/CaracterizacaoEfePecuaria"
              className={
                location.pathname === "/CaracterizacaoEfePecuaria"
                  ? classes.active
                  : ""
              }
              state={location.state}
            >
              <ListItemText
                sx={{
                  color: location.pathname === "/CaracterizacaoEfePecuaria" ? 'white' : 'black',
                  whiteSpace: open !== true ? 'nowrap' : "normal",
                  wordBreak: open !== true ? 'break-word' : "keep-all",
                }}
                disableTypography
                primary="3. Caraterização do Efetivo Pecuário"
              />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/RegistoProtFitossanitaria"
              className={
                location.pathname === "/RegistoProtFitossanitaria"
                  ? classes.active
                  : ""
              }
              state={location.state}
            >
              <ListItemText
                sx={{
                  color: location.pathname === "/RegistoProtFitossanitaria" ? 'white' : 'black',
                  whiteSpace: open !== true ? 'nowrap' : "normal",
                  wordBreak: open !== true ? 'break-word' : "keep-all",
                }}
                disableTypography
                primary="4. R. Proteção Fitossanitária e aplicação de biocidas"
              />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/RegistoOperCulturais"
              className={
                location.pathname === "/RegistoOperCulturais"
                  ? classes.active
                  : ""
              }
              state={location.state}

            >
              <ListItemText
                sx={{ color: location.pathname === "/RegistoOperCulturais" ? 'white' : 'black' }}
                disableTypography
                primary="5. R. Operações Culturais"
              />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/RegOperFertil"
              className={
                location.pathname === "/RegOperFertil" ? classes.active : ""
              }
              state={location.state}
            >
              <ListItemText
                sx={{ color: location.pathname === "/RegOperFertil" ? 'white' : 'black' }}
                disableTypography
                primary="5A. R. Operações Fertilização"
              />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/RegAtividades"
              className={
                location.pathname === "/RegAtividades" ? classes.active : ""
              }
              state={location.state}
            >
              <ListItemText disableTypography

                sx={{ color: location.pathname === "/RegAtividades" ? 'white' : 'black' }}
                primary="5B. Registo Atividades" />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/RegAtividPP"
              className={
                location.pathname === "/RegAtividPP" ? classes.active : ""
              }
              state={location.state}
            >
              <ListItemText
                disableTypography
                sx={{ color: location.pathname === "/RegAtividPP" ? 'white' : 'black' }}

                primary="5C. R. Ativividades Pastagens "
              />
            </ListItem>





            <ListItem
              // button
              component={Link}
              to="/RegAtividadesFO"
              className={location.pathname === "/RegAtividadesFO" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText
                sx={{
                  color: location.pathname === "/RegAtividadesFO" ? 'white' : 'black',
                  whiteSpace: open !== true ? 'nowrap' : "normal",
                  wordBreak: open !== true ? 'break-word' : "keep-all",
                }}
                disableTypography
                primary="5D. R. Ativ. Fertilização Orgânica "
              />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/RegCalRega"
              className={location.pathname === "/RegCalRega" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText disableTypography
                sx={{ color: location.pathname === "/RegCalRega" ? 'white' : 'black' }}

                primary="6. R. Calendário Rega" />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/RegProducaoAnimal"
              className={location.pathname === "/RegProducaoAnimal" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText disableTypography
                sx={{ color: location.pathname === "/RegProducaoAnimal" ? 'white' : 'black' }}

                primary="7. R. Produção Animal" />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/RegPosColheita"
              className={location.pathname === "/RegPosColheita" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText disableTypography
                sx={{ color: location.pathname === "/RegPosColheita" ? 'white' : 'black' }}

                primary="8. R. Pós-colheita" />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/RegAquisicoesEntra"
              className={location.pathname === "/RegAquisicoesEntra" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText
                sx={{ color: location.pathname === "/RegAquisicoesEntra" ? 'white' : 'black' }}
                disableTypography
                primary="9. R. Aquisições/Entradas"
              />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/RegVendas"
              className={location.pathname === "/RegVendas" ? classes.active : ""}
              state={location.state}
            >

              <ListItemText disableTypography
                sx={{ color: location.pathname === "/RegVendas" ? 'white' : 'black' }}

                primary="10. Registo vendas" />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/RegGestaoEP"
              className={location.pathname === "/RegGestaoEP" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText
                sx={{
                  color: location.pathname === "/RegGestaoEP" ? 'white' : 'black',
                  whiteSpace: open !== true ? 'nowrap' : "normal",
                  wordBreak: open !== true ? 'break-word' : "keep-all",
                }}
                disableTypography
                primary="11. R. Gestão Efluentes Pecuários"
              />
            </ListItem>
          </List>
        </Collapse>

        <Divider />
        <ListItemButton onClick={handleClickAnexos}>
          <ListItemIcon>
            <AttachFileTwoToneIcon sx={{ color: "#c94f1e" }} />
          </ListItemIcon>
          <ListItemText disableTypography primary={<strong>Anexos</strong>} />
          {openAnexos ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openAnexos} timeout="auto" unmountOnExit>
          <List component="div">
            <ListItem
              // button
              component={Link}
              to="/Anexo1"
              className={location.pathname === "/Anexo1" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText disableTypography
                sx={{ color: location.pathname === "/Anexo1" ? 'white' : 'black' }}
                primary="A1. Plano de Fertilização" />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/Anexo2"
              className={location.pathname === "/Anexo2" ? classes.active : ""}
              state={location.state}

            >
              <ListItemText
                sx={{ color: location.pathname === "/Anexo2" ? 'white' : 'black' }}
                disableTypography
                primary="A2. Plano Gestão Pastoreio"
              />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/Anexo3"
              className={location.pathname === "/Anexo3" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText disableTypography
                sx={{ color: location.pathname === "/Anexo3" ? 'white' : 'black' }}
                primary="A3. Plano Alimentar" />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/Anexo4"
              className={location.pathname === "/Anexo4" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText
                sx={{ color: location.pathname === "/Anexo4" ? 'white' : 'black' }}
                disableTypography
                primary="A4. P. Boas Práticas Higiéne"
              />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/Anexo5"
              className={location.pathname === "/Anexo5" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText disableTypography
                sx={{ color: location.pathname === "/Anexo5" ? 'white' : 'black' }}
                primary="A5. Plano de Reprodução" />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/Anexo6"
              className={location.pathname === "/Anexo6" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText
                disableTypography
                sx={{
                  color: location.pathname === "/Anexo6" ? 'white' : 'black',
                  whiteSpace: "normal",
                  wordBreak: "keep-all",
                }}
                primary="A6. Registo visitas de OC, ERR ou ELA"
              />
            </ListItem>
            <ListItem
              // button
              component={Link}
              to="/Anexo7"
              className={location.pathname === "/Anexo7" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText disableTypography
                sx={{ color: location.pathname === "/Anexo7" ? 'white' : 'black' }}
                primary="A7. Emissão de Parecer" />
            </ListItem>
          </List>
        </Collapse>
        <Divider />
        {/* Voltar para a página inicio */}
        <ListItemButton
          onClick={handleClickOpenDialog}
          style={{ marginBottom: 50 }}
        >
          <ListItemIcon>
            <ArrowBackTwoToneIcon sx={{ color: "#c94f1e" }} />
          </ListItemIcon>
          <ListItemText disableTypography primary="Voltar ao inicio" />
        </ListItemButton>

        {/* Rodapé */}

        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Tem a certeza que quer sair dos cadernos de campo?
            </DialogContentText>
            <DialogActions>
              <Button
                onClick={handleBack}
                sx={{
                  color: "#7e2706", fontFamily: "candara", fontSize: 18,
                }}
              >
                Sim
              </Button>
              <Button
                onClick={handleCloseDialog}
                sx={{
                  color: "#7e2706", fontFamily: "candara", fontSize: 18,
                }}
              >
                Cancelar
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>

        <Mudarvistatecnicoadmin
          open={openConnfirm}
          onClose={() => setOpenConfirm(false)}
          onConfirm={handleMudarView} />


      </List>
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        fontSize: 15,

      }}>
        {versao.versao}

      </div>
    </>
  );
}

//View inicial dos Tecnicos
export function TecnicoView() {
  const classes = useStyles();
  const location = useLocation();
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const [openConnfirm, setOpenConfirm] = useState(false);

  const handleMudarView = () => {
    ChangeRole(auth, navigate);
  };

  const handleClickOpenMudarView = (
    newAlignment: string,
  ) => {
    let aux_value = auth.user_role === 'admin' ? 'Administrador' : 'Consultor'
    if (newAlignment && newAlignment !== aux_value)
      setOpenConfirm(true);
  };

  return (
    <>
      <div style={{
        // backgroundColor: 'red',
        display: "flex",
        flexDirection: 'row',
        alignItems: "center",
        justifyContent: 'center',
        height: 45,
        marginTop: 10,
        marginBottom: 5,
        marginLeft: 4,
        marginRight: 4,
        borderRadius: 5,
        border: `1px solid ${cores.cor1}`,
      }}>
        <div style={{
          backgroundColor: auth.user_role === 'admin' ? cores.cor1 : 'white',
          display: "flex",
          flexDirection: 'row',
          alignItems: "center",
          justifyContent: 'center',
          flex: 0.5,
          height: '100%',
          color: auth.user_role === 'admin' ? 'white' : 'black',
          borderTopLeftRadius: 5,
          borderBottomLeftRadius: 5

        }}
          onClick={() => { handleClickOpenMudarView('admin') }}
        >
          Administrador
        </div>
        <div style={{
          backgroundColor: auth.user_role === 'tecnico' ? cores.cor1 : 'white',
          display: "flex",
          flexDirection: 'row',
          alignItems: "center",
          justifyContent: 'center',
          flex: 0.5,
          height: '100%',
          color: auth.user_role === 'tecnico' ? 'white' : 'black',
          borderTopRightRadius: 5,
          borderBottomRightRadius: 5

        }}
          onClick={() => { handleClickOpenMudarView('tecnico') }}

        >
          Consultor
        </div>
      </div>

      <List style={{ fontFamily: "candara", fontSize: 16, flex: 1 }}>

        <ListItem
          // button
          component={Link}
          to="/"
          className={location.pathname === "/" ? classes.active : ""}
        >
          <ListItemIcon>
            <HomeTwoToneIcon sx={{ color: "#c94f1e" }} />
          </ListItemIcon>
          <ListItemText sx={{ color: location.pathname !== "/" ? 'black' : 'white' }} disableTypography primary="Inicio" />
        </ListItem>

        <ListItem
          // button
          component={Link}
          to="/definicoestecnico"
          className={location.pathname === "/definicoestecnico" ? classes.active : ""}
        >
          <ListItemIcon>
            <SettingsTwoToneIcon sx={{ color: "#c94f1e" }} />
          </ListItemIcon>
          <ListItemText sx={{ color: location.pathname !== "/definicoestecnico" ? 'black' : 'white' }} disableTypography primary="Definições" />
        </ListItem>
        <ListItem
          // button
          component={Link}
          to="/tecnicosuporte"
          className={location.pathname === "/tecnicosuporte" ? classes.active : ""}
        >
          <ListItemIcon>
            <img
              src={img}
              alt="tecnicosuporte"
              style={{ width: "24px", height: "24px" }}
            />
          </ListItemIcon>
          <ListItemText sx={{ color: location.pathname === "/tecnicosuporte" ? 'white' : 'black' }} disableTypography primary="Suporte" />
        </ListItem>
        {/** Mudar de vista */}
        <Divider />


        <Mudarvistatecnicoadmin
          open={openConnfirm}
          onClose={() => setOpenConfirm(false)}
          onConfirm={handleMudarView} />

        <Divider />

        {/* Fazer logout do user */}
        <List style={{ fontFamily: "candara", fontSize: 16 }}>
          <OpcaoSair />
        </List>



        {/* Rodapé */}

      </List>
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        fontSize: 15,

      }}>
        {versao.versao}

      </div>
    </>
  );
}

/** menu lateral mínimo: só início e sair (sem definições, suporte ou mudança admin/consultor) */
export function AgricultorView() {
  const classes = useStyles();
  const location = useLocation();

  return (
    <>
      <List style={{ fontFamily: "candara", fontSize: 16, flex: 1 }}>
        <ListItem
          component={Link}
          to="/"
          className={location.pathname === "/" ? classes.active : ""}
        >
          <ListItemIcon>
            <HomeTwoToneIcon sx={{ color: "#c94f1e" }} />
          </ListItemIcon>
          <ListItemText
            sx={{ color: location.pathname === "/" ? "white" : "black" }}
            disableTypography
            primary="Início"
          />
        </ListItem>
        <Divider />
        <List style={{ fontFamily: "candara", fontSize: 16 }}>
          <OpcaoSair />
        </List>
      </List>
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          fontSize: 15,
        }}
      >
        {versao.versao}
      </div>
    </>
  );
}

export function EficienciaAlimentarView() {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useContext(AuthContext);

  const [openDialog, setOpenDialog] = React.useState(false);
  const [openConnfirm, setOpenConfirm] = useState(false);
  const [openEficiencia, setOpenEficiencia] = useState<boolean>(false);

  const handleMudarView = () => {
    ChangeRole(auth, navigate);
  };



  const handleClickOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const flag_abrir_eficiencia = () => {
    if (location.pathname === '/EFIdentBenfExp' ||
      location.pathname === '/EFPlanoAlimentar' ||
      location.pathname === '/EF_PA_GH1' ||
      location.pathname === '/EF_Caderno_Campos' ||
      location.pathname === '/EF_CC_GH1'
    ) {
      return true
    } else {
      return false
    }
  }


  const handleClickEficiencia = () => {
    setOpenEficiencia(!openEficiencia);
  };

  const handleBack = () => {
    navigate("/",);
  };

  useEffect(() => {
    setOpenEficiencia(flag_abrir_eficiencia())
  }, []);

  return (
    <>
      <List style={{ fontFamily: "candara", fontSize: 16, flex: 1 }}>
        <ListItemButton onClick={handleClickEficiencia}>
          <ListItemIcon>
            <PetsTwoToneIcon sx={{ color: "#c94f1e" }} />
          </ListItemIcon>
          <ListItemText
            disableTypography
            primary={<strong>Efic. Alimentar</strong>}

          />
          {openEficiencia ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openEficiencia} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              component={Link}
              to="/EFIdentBenfExp"
              className={location.pathname === "/EFIdentBenfExp" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText
                sx={{ color: location.pathname === "/EFIdentBenfExp" ? 'white' : 'black' }}
                disableTypography
                primary="1. Ident. beneficiário Exp."
              />
            </ListItem>
            <ListItem
              component={Link}
              to="/EFPlanoAlimentar"
              className={location.pathname === "/EFPlanoAlimentar" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText disableTypography
                sx={{ color: location.pathname === "/EFPlanoAlimentar" ? 'white' : 'black' }}
                primary="2. Plano Alimentar" />
            </ListItem>
            <ListItem
              component={Link}
              to="/EF_PA_GH1"
              className={location.pathname === "/EF_PA_GH1" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText disableTypography
                sx={{ color: location.pathname === "/EF_PA_GH1" ? 'white' : 'black' }}
                primary="2.1. PA - Grupos Homogéneos" />
            </ListItem>
            <ListItem
              component={Link}
              to="/EF_Caderno_Campos"
              className={
                location.pathname === "/EF_Caderno_Campos" ? classes.active : ""
              }
              state={location.state}

            >
              <ListItemText disableTypography
                sx={{ color: location.pathname === "/EF_Caderno_Campos" ? 'white' : 'black' }}

                primary="3. CC Caderno de campo" />
            </ListItem>
            <ListItem
              component={Link}
              to="/EF_CC_GH1"
              className={location.pathname === "/EF_CC_GH1" ? classes.active : ""}
              state={location.state}
            >
              <ListItemText disableTypography
                sx={{ color: location.pathname === "/EF_CC_GH1" ? 'white' : 'black' }}
                primary="3.1. CC Grupos homogéneos" />
            </ListItem>

          </List>
        </Collapse>



        <Divider />
        {/* Voltar para a página inicio */}
        <ListItemButton
          onClick={handleClickOpenDialog}
          style={{ marginBottom: 50 }}
        >
          <ListItemIcon>
            <ArrowBackTwoToneIcon sx={{ color: "#c94f1e" }} />
          </ListItemIcon>
          <ListItemText disableTypography primary="Voltar ao inicio" />
        </ListItemButton>

        {/* Rodapé */}

        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Tem a certeza que quer sair da secção Eficiência Alimentar?
            </DialogContentText>
            <DialogActions>
              <Button
                onClick={handleBack}
                sx={{
                  color: "#7e2706", fontFamily: "candara", fontSize: 18,
                }}
              >
                Sim
              </Button>
              <Button
                onClick={handleCloseDialog}
                sx={{
                  color: "#7e2706", fontFamily: "candara", fontSize: 18,
                }}
              >
                Cancelar
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>

        <Mudarvistatecnicoadmin
          open={openConnfirm}
          onClose={() => setOpenConfirm(false)}
          onConfirm={handleMudarView} />


      </List>
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        fontSize: 20,

      }}>
        {versao.versao}

      </div>
    </>
  );
}